import React, { useEffect, useState } from 'react'

// React components
import '../PointOfSaleManager.scss'
import styles from '.././PointOfSaleManager.module.scss'
import { GridData } from './GridData'
import { PointOfSaleReportDetailModal } from './PointOfSaleReportModal'
import {
    fetchPointOfSaleManager,
    fetchPointOfSaleReportDetail,
    FetchPointOfSaleReportDetailParams,
    fetchSavePointOfSaleReportDetail,
    emptyPointOfSaleReportDetail,
    UpdatePointOfSaleReportDetail,
    PointOfSaleReport,
    PointOfSaleReportDetail,
    PointOfSaleReportSaveResponse,
} from '../../features/invoice/invoiceAPI'

import { hasPOSManagerPermissions } from '../../features/meta/metaAPI'

import {
    fqAlert,
    NotificationManager,
    fqConfirm,
    fqConfirmAllowNo,
} from '../../GlobalComponents/NotificationManager/NotificationManager'
// import PointOfSaleManager from '../PointOfSaleManager'

export const PointOfSaleManagerDashboard: React.FC<{}> = () => {
    document.title = 'Point Of Sale Manager'

    // States for PointOfSale data
    const [data, setData] = useState<Array<PointOfSaleReport>>()
    const [loading, setLoading] = useState<boolean>(false)
    const [error, setError] = useState<string>('')
    const [initialLoading, setInitialLoading] = useState(true)
    const [allowed, setAllowed] = useState<boolean>(false)

    // Create/edit gateway modal form
    const [openDetailForm, setOpenDetailForm] = React.useState(false)

    const [selectedPointOfSaleReportDetail, setSelectedPointofSaleReportDetail] =
        React.useState<PointOfSaleReportDetail>()

    // Handle onChanges for PointOfSaleReportModal
    const descriptionHandleChange = (event: any) => {
        selectedPointOfSaleReportDetail &&
            setSelectedPointofSaleReportDetail({
                ...selectedPointOfSaleReportDetail,
                description: event.target.value,
            })
    }

    const activeHandleChange = (value: boolean) => {
        selectedPointOfSaleReportDetail &&
            setSelectedPointofSaleReportDetail({
                ...selectedPointOfSaleReportDetail,
                active: value,
            })
    }

    const frequencyHandleChange = (value: boolean) => {
        selectedPointOfSaleReportDetail &&
            setSelectedPointofSaleReportDetail({
                ...selectedPointOfSaleReportDetail,
                frequency: value ? 'Monthly' : 'Quarterly',
            })
    }

    const emailRecipientsHandleChange = (event: any) => {
        selectedPointOfSaleReportDetail &&
            setSelectedPointofSaleReportDetail({
                ...selectedPointOfSaleReportDetail,
                emailRecipients: event.target.value,
            })
    }
    const emailCCRecipientsHandleChange = (event: any) => {
        selectedPointOfSaleReportDetail &&
            setSelectedPointofSaleReportDetail({
                ...selectedPointOfSaleReportDetail,
                emailCCRecipients: event.target.value,
            })
    }
    const emailVerbiageHandleChange = (event: any) => {
        selectedPointOfSaleReportDetail &&
            setSelectedPointofSaleReportDetail({
                ...selectedPointOfSaleReportDetail,
                emailVerbiage: event.value,
            })
    }

    const emailSubjectHandleChange = (event: any) => {
        selectedPointOfSaleReportDetail &&
            setSelectedPointofSaleReportDetail({
                ...selectedPointOfSaleReportDetail,
                emailSubject: event.target.value,
            })
    }

    // Handle submission of edit point of sale report
    const handlePointOfSaleReportSubmit = (event: any) => {
        // Add point of sale report record to database
        SavePointOfSaleReportDetail({
            id: selectedPointOfSaleReportDetail!.id,
            reportName: selectedPointOfSaleReportDetail!.reportName,
            description: selectedPointOfSaleReportDetail!.description,
            active: selectedPointOfSaleReportDetail!.active,
            frequency: selectedPointOfSaleReportDetail!.frequency,
            emailSubject: selectedPointOfSaleReportDetail!.emailSubject,
            emailRecipients: selectedPointOfSaleReportDetail!.emailRecipients,
            emailCCRecipients: selectedPointOfSaleReportDetail!.emailCCRecipients,
            emailVerbiage: selectedPointOfSaleReportDetail!.emailVerbiage,
            reportType: selectedPointOfSaleReportDetail!.reportType,
            pointOfSaleReportLogs: [],
        })

        // Close point of sale detail modal
        setOpenDetailForm(false)
    }

    // Save point of sale report
    async function SavePointOfSaleReportDetail(
        savePointOfSaleReportDetail: PointOfSaleReportDetail
    ) {
        try {
            // fetchSavePointOfSaleReportDetail()
            if (await UpdatePointOfSaleReportDetail(savePointOfSaleReportDetail)) {
                getPointOfSaleManager()
                fqAlert({
                    type: 'success',
                    message: 'Update Succesful!',
                })
            } else {
                fqAlert({
                    type: 'error',
                    title: 'Error',
                    message: 'Error saving point of sale detail data!',
                })
            }
        } catch (error) {
            console.error('Error saving point of sale manager')
            fqAlert({
                type: 'error',
                title: 'Error',
                message: 'Error saving point of sale detail data!',
            })
        }
    }

    // Get the row we want to edit
    const editRowClick = (event: any) => {
        enterEdit(event.dataItem)
    }

    // Edit Point of Sale Report Detail form
    const enterEdit = (editPointOfSaleReportDetail: PointOfSaleReport) => {
        let pointOfSaleReportDetailParams: FetchPointOfSaleReportDetailParams = {
            ID: editPointOfSaleReportDetail.id,
        }

        try {
            getPointOfSaleReportDetail(pointOfSaleReportDetailParams)
        } catch (error) {
            console.error(error)
            fqAlert({
                type: 'error',
                title: 'Error',
                message: 'Error displaying detail data!',
            })
        }
    }
    useEffect(() => {
        if (selectedPointOfSaleReportDetail) setOpenDetailForm(true)
    }, [selectedPointOfSaleReportDetail])

    // Cancel create/edit PointOfSaleReportDetail (close dialog without saving)
    const handleCancelDialog = () => {
        setSelectedPointofSaleReportDetail(undefined)
        getPointOfSaleManager() // Refresh grid data
        setOpenDetailForm(false)
    }

    // Fetch data for point of sale report detail
    async function getPointOfSaleReportDetail(
        pointOfSaleReportDetailParams: FetchPointOfSaleReportDetailParams
    ) {
        let selectedDetail: PointOfSaleReportDetail | undefined
        try {
            selectedDetail = await fetchPointOfSaleReportDetail(pointOfSaleReportDetailParams)
        } catch (error) {
            console.error('Error fetching point of sale manager')
            fqAlert({
                type: 'error',
                title: 'Error',
                message: 'Error retrieving detail data!',
            })
        }

        if (selectedDetail) {
            setSelectedPointofSaleReportDetail(selectedDetail)
        }
    }

    // Fetch data for grid
    async function getPointOfSaleManager() {
        let posManagerData: PointOfSaleReport[] = []
        try {
            posManagerData = await fetchPointOfSaleManager()
        } catch (error) {
            console.error('Error fetching point of sale manager')
            fqAlert({
                type: 'error',
                title: 'Error',
                message: 'Error retrieving manager data!',
            })
            posManagerData = []
        }

        if (posManagerData) {
            setData(posManagerData)
        }
    }

    const initLoad = async () => {
        let hasPerms = await hasPOSManagerPermissions()
        setAllowed(hasPerms)
        setInitialLoading(false)
    }

    useEffect(() => {
        initLoad()
    }, [])

    useEffect(() => {
        if (allowed) getPointOfSaleManager()
    }, [allowed])

    if (initialLoading)
        return (
            <div className={styles.app}>
                <div className={'centered'}>
                    <div className={'k-i-loading'} style={{ fontSize: 200, height: '90vh' }} />
                </div>
                <NotificationManager key={'notificationsManager'} />
            </div>
        )

    if (!allowed)
        return (
            <div
                className={`${styles.alert} ${styles.alertDanger}`}
                role='alert'
                style={{
                    textAlign: 'center',
                    marginTop: 60,
                }}
            >
                <h3>Permission Denied</h3>
                <p>POS Permissions are required to access POS Reports!</p>
            </div>
        )

    return (
        <div className={`${styles.PointOfSaleManager} PointOfSaleManager`}>
            <div className={styles.App}>
                <div className={styles.Header}>
                    <h1>Point of Sale Report Manager</h1>
                </div>
                <GridData data={data} loading={loading} error={error} editRowClick={editRowClick} />
                {openDetailForm && (
                    <PointOfSaleReportDetailModal
                        pointOfSaleReportDetail={selectedPointOfSaleReportDetail}
                        cancelDialog={handleCancelDialog}
                        onSubmit={handlePointOfSaleReportSubmit}
                        descriptionHandleChange={descriptionHandleChange}
                        activeHandleChange={activeHandleChange}
                        frequencyHandleChange={frequencyHandleChange}
                        emailRecipientsHandleChange={emailRecipientsHandleChange}
                        emailCCRecipientsHandleChange={emailCCRecipientsHandleChange}
                        emailSubjectHandleChange={emailSubjectHandleChange}
                        emailVerbiageHandleChange={emailVerbiageHandleChange}
                    />
                )}
            </div>
            <NotificationManager key={'notificationsManager'} />
        </div>
    )
}
